import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.287 13.95a.563.563 0 0 0 .788-.112 3.656 3.656 0 0 1 5.85 0 .561.561 0 0 0 1.007-.258.56.56 0 0 0-.107-.418 4.8 4.8 0 0 0-1.927-1.525 2.813 2.813 0 1 0-3.792 0 4.8 4.8 0 0 0-1.931 1.525.563.563 0 0 0 .112.788M9 7.875a1.687 1.687 0 1 1 0 3.375 1.687 1.687 0 0 1 0-3.375m5.063-6.187H3.938a1.125 1.125 0 0 0-1.126 1.125v12.375a1.125 1.125 0 0 0 1.126 1.124h10.125a1.125 1.125 0 0 0 1.124-1.125V2.813a1.125 1.125 0 0 0-1.124-1.126m0 13.5H3.938V2.813h10.125zM6.187 4.5a.563.563 0 0 1 .563-.562h4.5a.562.562 0 1 1 0 1.124h-4.5a.563.563 0 0 1-.562-.562"
    }, null, -1)
  ])))
}
export default { render: render }